import Link from "next/link";
import React from "react";

type Props = {
  breadcrumbs: {
    name: string;
    url: string;
  }[];
};

const BreadCrumbList = (props: Props) => {
  return (
    <section id="bread-crumbs" className="px-2 py-6 mx-auto text-sm max-w-7xl">
      <div className="flex flex-wrap lg:space-y-0">
        {props.breadcrumbs.map((breadcrumb, index) => {
          return (
            <div className="flex gap-2 pl-1" key={index}>
              {index === props.breadcrumbs.length - 1 ? (
                <div className=" text-my-dark-blue">
                  <p
                    className={
                      index === props.breadcrumbs.length - 1 ? `font-bold` : ``
                    }
                  >
                    {breadcrumb.name}
                  </p>
                </div>
              ) : (
                <Link
                  href={breadcrumb.url}
                  className="cursor-pointer text-my-dark-blue hover:underline"
                >
                  <p
                    className={
                      index === props.breadcrumbs.length - 1 ? `font-bold` : ``
                    }
                  >
                    {breadcrumb.name}
                  </p>
                </Link>
              )}
              {index < props.breadcrumbs.length - 1 && <p>&gt;</p>}
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default BreadCrumbList;
